import type { ClientGroupProductPriceSuggestion } from "@stockline/shared/types/ai/client-group-product-price-suggestion"
import type { OfflineResourceConfig } from "../../../types"
import { CLIENT_GROUP_PRODUCT_PRICE_SUGGESTION_TABLE } from "./db"

export const clientGroupProductPriceSuggestionConfig: OfflineResourceConfig<ClientGroupProductPriceSuggestion> =
  {
    name: "client-group-product-price-suggestions",
    endpoints: {
      full: "/api/v2/client-group-product-price-suggestions",
      delta: "/api/v2/client-group-product-price-suggestions/changes",
      push: "/api/v2/client-group-product-price-suggestions/changes",
    },
    tableName: CLIENT_GROUP_PRODUCT_PRICE_SUGGESTION_TABLE,
    primaryKey: "id",
    indexes: {
      companyId: "companyId",
      targetId: "targetId",
    },
    applyChange: (local, patch) => ({ ...local, ...patch }),
    // Tombstones stay in Dexie (pulls deliver them as upserts carrying
    // `deletedAt`); readers filter `deletedAt` themselves.
    softDelete: true,
  }
